import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TablerIconsModule } from 'angular-tabler-icons';

export interface ExchangeRateCardData {
  title?: string;
  lastUpdatedLabel: string;
  date: Date;
  buy: number;
  sell: number;
  closeBuy: number;
  closeSell: number;
}

const EXCHANGE_CARD_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'dd/MM/yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'dd/MM/yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};

@Component({
  selector: 'app-exchange-rate-card',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    TablerIconsModule,
  ],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: EXCHANGE_CARD_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'es-PE' },
  ],
  templateUrl: './exchange-rate-card.component.html',
  styleUrl: './exchange-rate-card.component.scss',
})
export class ExchangeRateCardComponent implements OnChanges {
  @Input() data: ExchangeRateCardData

  @Output() manage = new EventEmitter<void>();
  @Output() openMonthly = new EventEmitter<void>();
  @Output() dateChange = new EventEmitter<Date>();

  @Input() isLoading: boolean = false;
  @Input() isEmpty: boolean = false;

  dateCtrl = new FormControl<Date | null>(null);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']?.currentValue) {
      const dateValue = this.data?.date ?? null;
      this.dateCtrl.setValue(dateValue, { emitEvent: false });
    }
  }

  onDateChange(event: MatDatepickerInputEvent<Date>): void {
    if (event.value) {
      this.dateChange.emit(event.value);
    }
  }

  onMonthlyRate(): void {
    this.openMonthly.emit();
  }

  onManage(): void {
    this.manage.emit();
  }
}
